import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';


const Sidebar = ({ isCollapsed, onToggle }) => {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const [mobileOpen, setMobileOpen] = useState(false);

  // const logout = () => {
  //   const cookieNames = [
  //     'user_id', 'auth_key', 'api_key',
  //     'auth_refresh_key', 'surname', 'name',
  //     'email', 'authenticated'
  //   ];
    
  //   cookieNames.forEach(name => cookies.remove(name, { path: '/' }));
  //   window.location.href = 'https://cbthost.com';
  // };


  const logout = () => {
  const cookieNames = [
    'auto_login_code',
    'auth_key',
    'access_token',
    'name',
    'email',
    'authenticated',
    'user_type',
    'user_id'
  ];

  cookieNames.forEach(name => {
    cookies.remove(name, { path: '/' });
  });

  window.location.href = 'https://cbthost.com';
};



  const toggleMobileMenu = () => {
    setMobileOpen(!mobileOpen);
  };

  const navigateTo = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  const menuItems = [
    { path: '/cbt_creator/dashboard', icon: 'fas fa-home', label: 'Home' },
    { path: '/participate/dashboard', icon: 'fas fa-vote-yea', label: 'Participate in Test' },
    { path: '/cbt_creator/cbts', icon: 'fas fa-plus', label: 'Create Test' },
    // { path: '/cbt_creator/create_cbt', icon: 'fas fa-plus', label: 'Create Test' },
    { path: '/cbt_creator/offline-export', icon: 'fas fa-download', label: 'Offline Export' },
    { path: '/cbt_creator/question_transfer', icon: 'fas fa-cloud', label: 'Data Transfer' },
    { path: '/cbt_creator/analytics', icon: 'fas fa-chart-line', label: 'Analytics' },
    { path: '/cbt_creator/label-selector', icon: 'fas fa-tags', label: 'Label Selector' },
    // { path: '/cbt_creator/api_key', icon: 'fas fa-key', label: 'API Key' },
    { path: '/cbt_creator/payment', icon: 'fas fa-credit-card', label: 'Payment' },
    { path: '/cbt_creator/subscription/users', icon: 'fas fa-user-check', label: 'Active users' },
    // { path: '/cbt_creator/subscription/join', icon: 'fas fa-user-plus', label: 'Join' },
//     {

//   path: "/cbt_creator/all-invitations",  
//   icon: "fas fa-envelope", label: "My Invitations"
// },

    { path: '/cbt_creator/subscription/invitations', icon: 'fas fa-users', label: 'Invitations' },
    { path: '/cbt_creator/profile', icon: 'fas fa-user', label: 'Profile' },
    // { path: '/cbt_creator/cbt_img_library', icon: 'fas fa-folder-open', label: 'Images' },
  ];

  return (
    <>
      {/* Mobile Navigation Toggle */}
      <nav className="lg:hidden fixed top-0 left-0 right-0 z-40 bg-gray-800 shadow-md">
        <div className="flex items-center justify-between px-4 py-3">
          <button 
            className="text-white focus:outline-none"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <i className="fas fa-bars text-xl"></i>
          </button>
          <span className="text-white font-medium text-lg">Menu</span>
          <div className="w-8"></div>
        </div>
      </nav>

      {/* Desktop Sidebar */}
      <div 
        className={`hidden lg:flex flex-col fixed top-0 left-0 bottom-0 z-30 bg-gray-800 transition-all duration-300 ease-in-out ${
          isCollapsed ? 'w-20' : 'w-64'
        }`}
      >
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-gray-700">
          {!isCollapsed && (
            <h5 className="text-white text-lg font-semibold">Dashboard</h5>
          )}
          <button 
            className="text-white hover:text-gray-300 focus:outline-none"
            onClick={onToggle}
            aria-label={isCollapsed ? "Expand menu" : "Collapse menu"}
          >
            <i className={`fas ${isCollapsed ? 'fa-bars' : 'fa-times'} text-lg`}></i>
          </button>
        </div>

        {/* Scrollable Menu */}
        <div className="flex-1 overflow-y-auto py-2 scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-gray-800 hover:scrollbar-thumb-gray-500">
          {menuItems.map((item, index) => (
            <button
              key={index}
              className="flex items-center w-full px-4 py-3 text-left text-gray-300 hover:bg-gray-700 hover:text-white transition-colors duration-200 focus:outline-none"
              onClick={() => navigateTo(item.path)}
              aria-label={item.label}
            >
              <i className={`${item.icon} text-lg ${isCollapsed ? '' : 'mr-3'}`}></i>
              {!isCollapsed && <span>{item.label}</span>}
            </button>
          ))}




          <button
            className="flex items-center w-full px-4 py-3 text-left text-gray-300 hover:bg-gray-700 hover:text-white transition-colors duration-200 focus:outline-none"
            onClick={logout}
            aria-label="Logout"
          >
            <i className={`fas fa-sign-out-alt text-lg ${isCollapsed ? '' : 'mr-3'}`}></i>
            {!isCollapsed && <span>Logout</span>}
          </button>
        </div>

        {/* Footer */}
        <div className="p-3 text-center border-t border-gray-700">
          {!isCollapsed && (
            <div className="text-gray-400 text-xs">
              &copy; {new Date().getFullYear()} CBTHOST.COM
            </div>
          )}
        </div>
      </div>

      {/* Mobile Menu Modal */}
      <div 
        className={`fixed inset-0 z-50 transition-opacity duration-300 lg:hidden ${
          mobileOpen 
            ? 'opacity-100 pointer-events-auto' 
            : 'opacity-0 pointer-events-none'
        }`}
      >
        {/* Backdrop */}
        <div 
          className="absolute inset-0 bg-black bg-opacity-50"
          onClick={toggleMobileMenu}
        ></div>
        
        {/* Menu Panel */}
        <div 
          className={`absolute top-0 left-0 bottom-0 w-64 bg-gray-800 transform transition-transform duration-300 flex flex-col ${
            mobileOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
        >
          {/* Header */}
          <div className="flex justify-between items-center p-4 border-b border-gray-700">
            <h5 className="text-white text-lg font-semibold">Dashboard Menu</h5>
            <button 
              className="text-white hover:text-gray-300 focus:outline-none"
              onClick={toggleMobileMenu}
              aria-label="Close menu"
            >
              <i className="fas fa-times text-lg"></i>
            </button>
          </div>

          {/* Scrollable Menu */}
          <div className="flex-1 overflow-y-auto py-2 scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-gray-800 hover:scrollbar-thumb-gray-500">
            {menuItems.map((item, index) => (
              <button
                key={index}
                className="flex items-center w-full px-4 py-3 text-left text-gray-300 hover:bg-gray-700 hover:text-white transition-colors duration-200 focus:outline-none"
                onClick={() => navigateTo(item.path)}
              >
                <i className={`${item.icon} text-lg mr-3`}></i>
                <span>{item.label}</span>
              </button>
            ))}

            <button
              className="flex items-center w-full px-4 py-3 text-left text-gray-300 hover:bg-gray-700 hover:text-white transition-colors duration-200 focus:outline-none"
              onClick={logout}
            >
              <i className="fas fa-sign-out-alt text-lg mr-3"></i>
              <span>Logout</span>
            </button>
          </div>

          {/* Footer */}
          <div className="p-3 text-center border-t border-gray-700">
            <div className="text-gray-400 text-xs">
              &copy; {new Date().getFullYear()} CBTHOST.COM
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { Sidebar };
